<section class="modal-body row justify-content-around d-flex flex-column align-content-center p-5">
  <button type="button" class="close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="TiposolicitudClass">
    <label class="font-weight-bold text-dark" >Tipos de solicitudes</label>
    <p>Estas son las solicitudes donde se permitirá realizar el cambio de subcategoría.</p>
    <mat-selection-list [(ngModel)]="selectedValue" class="TiposolicitudList">
      <mat-list-option *ngFor="let item of tipoSolicitud" [value]="item.tipo_solicitud_id" [disabled]="true">
        {{item.descripcion}} 
      </mat-list-option>
    </mat-selection-list>
  </div>
</section>